import { render, staticRenderFns } from "./termsAndConditionsModal.vue?vue&type=template&id=24e84840"
import script from "./termsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./termsAndConditionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports